const appConfig = {
    // scp -r ./build/* root@178.62.118.252:/var/www/hrms/
    apiPrefix: 'https://api2.hrms.co.tz',
    // apiPrefix: process.env.REACT_APP_API_PREFIX || 'https://api.hrms.co.tz',
    authenticatedEntryPath: '/company',
    // authenticatedDeveloperEntryPath: '/developer',
    authenticatedDeveloperEntryPath: '/businesses/list',
    // authenticatedCompanyEntryPath: '/company',
    authenticatedBusinessEntryPath: '/logbook',
    authenticatedSchoolEntryPath: '/school',
    authenticatedGuestEntryPath: '/guest',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    enableMock: false
}

export default appConfig
